export const PLAYER_INIT = 'PLAYER_INIT';
export const PLAYER_START = 'PLAYER_START';
export const PLAYER_TOGGLE = 'PLAYER_TOGGLE';
export const PLAYER_SEEK_TO = 'PLAYER_SEEK_TO';
export const PLAYER_SEEK_RESET = 'PLAYER_SEEK_RESET';
export const PLAYER_UPDATE_PROGRESS = 'PLAYER_UPDATE_PROGRESS';
export const PLAYER_LOG_PROGRESS = 'PLAYER_LOG_PROGRESS';
export const PLAYER_SET_ACTIVE_CUEPOINT = 'PLAYER_SET_ACTIVE_CUEPOINT';
export const PLAYER_UNLOAD = 'PLAYER_UNLOAD';
export const PLAYER_REMOVE = 'PLAYER_REMOVE';
// export const PLAYER_ = 'PLAYER_';

export const playerInit = (uid, properties) => ({
  type: PLAYER_INIT,
  payload: { uid, properties },
});

export const playerStart = uid => ({
  type: PLAYER_START,
  payload: { uid },
});

export const playerToggle = (uid, isPlaying) => ({
  type: PLAYER_TOGGLE,
  payload: { uid, isPlaying },
});

export const playerSeekTo = (uid, time) => ({
  type: PLAYER_SEEK_TO,
  payload: { uid, time },
});

export const playerSeekReset = uid => ({
  type: PLAYER_SEEK_RESET,
  payload: { uid },
});

export const playerUpdateProgress = (uid, progress) => ({
  type: PLAYER_UPDATE_PROGRESS,
  payload: { uid, progress },
});

export const playerLogProgress = (uid, percent) => ({
  type: PLAYER_LOG_PROGRESS,
  payload: { uid, percent },
});

export const playerSetActiveCuePoint = (uid, data) => ({
  type: PLAYER_SET_ACTIVE_CUEPOINT,
  payload: { uid, data },
});

export const playerUnload = uid => ({
  type: PLAYER_UNLOAD,
  payload: { uid },
});

export const playerRemove = uid => ({
  type: PLAYER_REMOVE,
  payload: { uid },
});



// WEBPACK FOOTER //
// ./src/actions/playerActions.js